import request from '@/utils/request';
import {
  datasetConversionEndpoint,
  dictionaryConversionEndpoint,
  datasetValidationEndpoint,
  dictionaryValidationEndpoint,
} from '@/constants/urls';

const convertDataset = (code) => request({
  method: 'POST',
  url: datasetConversionEndpoint(code),
});

const convertDictionary = (code) => request({
  method: 'POST',
  url: dictionaryConversionEndpoint(code),
});

const validateDataset = (code) => request({
  method: 'GET',
  url: datasetValidationEndpoint(code),
});

const validateDictionary = (code) => request({
  method: 'GET',
  url: dictionaryValidationEndpoint(code),
});

const DatasetDataManagementService = {
  convertDataset,
  convertDictionary,
  validateDataset,
  validateDictionary,
};

export default DatasetDataManagementService;
